import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReset() {
    this.setState({ hasError: false, error: null });
    window.location.href = '/dashboard';
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <div className="text-6xl mb-6">⚠</div>
            <h1 className="text-2xl font-bold uppercase tracking-tight mb-3 text-[#FF6B00]">
              Algo salió mal
            </h1>
            <p className="text-[#A3A3A3] mb-4 text-sm">
              Ocurrió un error inesperado en esta página. Intenta volver al inicio o actualiza la página.
            </p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={() => this.handleReset()}
                className="bg-[#C2410C] hover:bg-[#9A3412] text-white font-bold uppercase tracking-wider px-6 py-3 text-sm transition-colors"
              >
                Ir al inicio
              </button>
              <button
                onClick={() => window.location.reload()}
                className="bg-[#262626] hover:bg-[#333333] text-white border border-[#333333] font-bold uppercase tracking-wider px-6 py-3 text-sm transition-colors"
              >
                Actualizar
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
